import { useState } from 'react';

import {
  Button,
  Icon,
  Popover,
  PopoverClose,
  PopoverContent,
  PopoverTrigger,
  Stack,
} from '@eluve/components';
import { useAppointmentId } from '@eluve/frontend-appointment-hooks';
import { useTranslation } from '@eluve/i18n';

import { useTranscriptionMachineSelector } from './appointments/machines/transcription/hooks/useTranscriptionMachine';

export const TranscriptionConfidenceAlert: React.FC = () => {
  const { t } = useTranslation();
  const appointmentId = useAppointmentId();
  const [userDismissed, setUserDismissed] = useState(false);

  const isMuted = useTranscriptionMachineSelector(
    (state) => state.context.microphoneStatus === 'muted',
  );

  const isAppointmentInSession = useTranscriptionMachineSelector(
    (state) => state.context.sessionAppointmentId === appointmentId,
  );

  const isLowConfidence = useTranscriptionMachineSelector(
    (state) => state.context.isLowConfidenceTranscription,
  );

  const isOpen = !userDismissed && isLowConfidence;
  const handleClose = () => setUserDismissed(true);

  if (!isAppointmentInSession || isMuted) return null;

  return (
    <div className="absolute bottom-full left-0">
      <Popover open={isOpen} onOpenChange={handleClose}>
        <PopoverTrigger asChild>
          <div className="pointer-events-none size-0.5" />
        </PopoverTrigger>
        <PopoverContent
          side="bottom"
          align="start"
          className="rounded-lg bg-text-primary px-2.5 py-1.5 text-white shadow-md"
        >
          <Stack justify="between" align="start" gap={2} direction="horizontal">
            <Stack gap={2}>
              <span className="text-xs font-semibold text-inherit">
                {t('home.transcriptionConfidence.tooFarTitle')}
              </span>
              <span className="text-xs font-medium text-text-supporting">
                {t('home.transcriptionConfidence.tooFarDescription')}
              </span>
            </Stack>
            <PopoverClose asChild>
              <Button size="sm" onClick={handleClose}>
                <Icon name="X" size="auto" />
              </Button>
            </PopoverClose>
          </Stack>
        </PopoverContent>
      </Popover>
    </div>
  );
};
